import * as React from "react";

const SvgIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="60"
        height="35"
        fill="none"
        viewBox="0 0 82 41"
    >
        <path
            fill="#3CC8A1"
            d="M37.72 23.238C28.351 22.768 7.976 17.464 1.425 0-2.485 7.98-.7 23.801 37.72 23.238"
        ></path>
        <path
            fill="#3CC8A1"
            d="M34.622 25.116c-7.156.078-23.017-1.033-29.214-6.103-.442 5.242 4.78 13.802 29.214 6.103"
        ></path>
        <path
            fill="#3CC8A1"
            d="M35.065 26.759c-6.271 1.956-19.963 5.21-24.566 2.582.516 4.381 6.152 10 24.566-2.582M35.507 28.871c-4.353 3.052-13.854 8.873-17.041 7.746 1.328 3.052 6.595 5.775 17.04-7.746M36.613 30.75c-2.213 3.05-7.17 9.2-9.295 9.388 1.402 1.643 5.223 2.066 9.295-9.389M44.28 23.238C53.65 22.768 74.024 17.464 80.575 0c3.91 7.98 2.125 23.801-36.295 23.238"
        ></path>
        <path
            fill="#3CC8A1"
            d="M47.378 25.116c7.156.078 23.017-1.033 29.214-6.103.443 5.242-4.78 13.802-29.214 6.103"
        ></path>
        <path
            fill="#3CC8A1"
            d="M46.936 26.759c6.27 1.956 19.962 5.21 24.566 2.582-.517 4.381-6.153 10-24.566-2.582M46.493 28.871c4.353 3.052 13.854 8.873 17.041 7.746-1.328 3.052-6.595 5.775-17.04-7.746M45.387 30.75c2.213 3.05 7.17 9.2 9.295 9.388-1.402 1.643-5.223 2.066-9.295-9.389"
        ></path>
    </svg>
);

export default SvgIcon;
